
/**
 * @description Takes one or more transitions and play them back to back
 * @internal This is an internal class utilized by the videoTransitionManager
 */
class TransitionSequence {
    /**
     * 
     * @param {*} elements 
     * @param {*} transitions 
     * @param {*} onComplete 
     */
    constructor(elements, transitions, onComplete) {
        this.radio = new Vue({});
        this.container = elements.container;
        this.videos = [];
        this.numComplete = 0;
        this.onComplete = onComplete;

        transitions.forEach(transition => {
            var video = new TransitionVideoPlayer(this.radio, elements, transition);
            this.videos.push(video)
        })

        this.eventHandlers = {
            "ended": () => {
                this.onVideoComplete();
            }
        }

        this.radio.$on("ended", this.eventHandlers.ended);
    }

    play() {
        this.videos[this.numComplete].play();
    }

    destroy () {
        this.radio.$off("ended", this.eventHandlers.ended);
    }

    onVideoComplete() {
        this.numComplete++;
        if (this.numComplete >= this.videos.length) {
            // COMPLETE
            this.container.classList.remove('transition-video--visible');
            this.onComplete();
        } else {
            this.play();
        }
    }

}
